import { PROGRAMS_PROGRAMS_NEW } from "@/routing";
import AddRounded from "@mui/icons-material/AddRounded";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Option from "@mui/joy/Option";
import Select from "@mui/joy/Select";
import Stack from "@mui/joy/Stack";
import { useLocation } from "wouter";
import { useCurrentProgram } from "./CurrentProgramProvider";

/** Renders inside the Programs sidebar section. Lists all programs in the
 *  current org and lets the user switch which one is "current". When no
 *  programs exist, shows a CTA to create the first one. */
export const CurrentProgramSelector = () => {
  const { programs, currentProgram, setCurrentProgramId, loading } =
    useCurrentProgram();
  const [, setLocation] = useLocation();

  if (loading) {
    return (
      <Box sx={{ px: 1, pb: 0.5 }}>
        <Select size="sm" placeholder="Loading…" disabled />
      </Box>
    );
  }

  if (programs.length === 0) {
    return (
      <Box sx={{ px: 1, pb: 0.5 }}>
        <Button
          size="sm"
          variant="soft"
          fullWidth
          startDecorator={<AddRounded />}
          onClick={() => setLocation(PROGRAMS_PROGRAMS_NEW)}
        >
          Create first program
        </Button>
      </Box>
    );
  }

  return (
    <Box>
      <Stack spacing={0.5}>
        {/* <FormHelperText sx={{ fontSize: "xs", m: 0 }}>
          Select a program
        </FormHelperText> */}
        <Select
          size="sm"
          value={currentProgram?.id ?? null}
          onChange={(_, v) => setCurrentProgramId(v)}
          placeholder="Select a program"
          sx={{ textOverflow: "ellipsis" }}
        >
          {programs.map((p) => (
            <Option key={p.id} value={p.id}>
              {p.name}
            </Option>
          ))}
        </Select>
      </Stack>
    </Box>
  );
};

export default CurrentProgramSelector;
